/* eslint-disable */
import React from "react";

import Modal from "../../components/ui/Modal";
import { MailIcon, MobileIcon, SuccessIcon } from "../../assets/Icons";
import clsx from "clsx";
import { getSignedStatus, sendA2Form } from "../../services/reviewPage";
import ErrorField from "../../components/ui/ErrorField";
import Button from "../../components/ui/Button";

export const EsignHistoryModal: React.FC<IEsignModal.EsignProps> = ({
  isEsignModal,
  setIsEsignModal,
  modalTitle,
  handleA2Form,
  handleLinkSent,
  remitterId,
  isResign,
}) => {
  const [mobileActive, setMobileActive] = React.useState<boolean>(false);
  const [mailActive, setMailActive] = React.useState<boolean>(false);
  const [step, setStep] = React.useState<string>("2");
  const [error, setError] = React.useState<string>("");
  const [linkSent, setLinkSent] = React.useState<boolean>(false);
  const [timeLeft, setTimeLeft] = React.useState(60);
  const [isTimeUp, setIsTimeUp] = React.useState(false);
  const [clickedCount, setClickedCount] = React.useState<number>(0);

  const [isDisabled, setIsDisabled] = React.useState({
    mobileLoader: false,
    emailLoader: false,
  });

  React.useEffect(() => {
    let interval: any;
    if (isEsignModal?.isModalOpen) {
      interval = setInterval(() => {
        handleEsignedStatus();
      }, 3000);
    }
    return () => clearInterval(interval);
  }, [isEsignModal?.isModalOpen, step]);

  React.useEffect(() => {
    if (isEsignModal?.isModalOpen === true && isEsignModal?.modalName === "mobile") {
      setMobileActive(true);
      if (clickedCount > 2) {
        handleMobileNumber();
        timeLeft === 0 && setTimeLeft(60);
      } else {
        handleMobileNumber();
      }
    } else if (isEsignModal?.isModalOpen === true && isEsignModal?.modalName === "email") {
      setMailActive(true);
      if (clickedCount > 2) {
        handleMail();
        timeLeft === 0 && setTimeLeft(60);
      } else {
        handleMail();
      }
    }
  }, [isEsignModal]);

  React.useEffect(() => {
    if (clickedCount > 2 && timeLeft !== 0) {
      const timer = setInterval(() => {
        setTimeLeft((prevTime) => {
          if (prevTime <= 1) {
            clearInterval(timer);
            setIsTimeUp(true);
            return 0;
          }
          return prevTime - 1;
        });
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [clickedCount, timeLeft]);

  const handleEsignedStatus = () => {
    if (isEsignModal?.isModalOpen) {
      if (step === "2") {
        getSignedStatus({
          userId: remitterId,
        })
          .then((response) => {
            setError("");
            if (response?.data?.signed) {
              if (step === "2") {
                setStep("3");
              }
            }
          })
          .catch((error) => {
            setError(error?.response?.data?.error?.type);
          });
      }
    }
  };

  const handleMobileNumber = (clickType?: string) => {
    setMobileActive(true);
    clickedCount < 1
      ? setTimeLeft(60)
      : clickType !== "popup" && clickedCount >= 2 && timeLeft === 0 && setTimeLeft(60);
    setClickedCount(clickedCount + 1);
    setIsTimeUp(false);
    setIsDisabled((prev) => ({ ...prev, emailLoader: true }));
    setMailActive(false);
    sendA2Form({
      sendType: "sms",
      userId: remitterId,
      transactionNumber: null,
      resend: isResign,
    })
      .then(() => {
        setStep("2");
        setError("");
        setLinkSent(true);
      })
      .catch((error) => {
        setError(error?.response?.data?.error?.type);
        setTimeout(() => {
          setError("");
        }, 3000);
      })
      .finally(() => setIsDisabled((prev) => ({ ...prev, mobileLoader: false })));
  };

  const handleMail = (clickType?: string) => {
    setMobileActive(false);
    clickedCount < 1
      ? setTimeLeft(60)
      : clickType == "popup" && clickedCount > 2 && timeLeft === 0 && setTimeLeft(60);
    setClickedCount(clickedCount + 1);
    setIsTimeUp(false);
    setIsDisabled((prev) => ({ ...prev, emailLoader: true }));
    setMailActive(true);
    sendA2Form({
      sendType: "Mail",
      userId: remitterId,
      transactionNumber: null,
      resend: isResign,
    })
      .then(() => {
        setStep("2");
        setError("");
        setLinkSent(true);
      })
      .catch((error) => {
        setError(error?.response?.data?.error?.type);
        setTimeout(() => {
          setError("");
        }, 3000);
      })
      .finally(() => setIsDisabled((prev) => ({ ...prev, emailLoader: false })));
  };

  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${String(minutes).padStart(2, "0")}.${String(remainingSeconds).padStart(2, "0")}`;
  };

  return (
    <Modal
      modalClass="!p-0 md:pr-11 flex p-0 flex-col !rounded lg:!w-6/12 !w-full"
      headerClass="!mt-0 items-center text-white sticky h-24 pr-4 pl-[42%] bg-primary font-bold text-2xl"
      visible={isEsignModal?.isModalOpen}
      header={modalTitle ? modalTitle : "Sign A2 Form"}
      closeHandler={() => {
        if (linkSent) {
          handleLinkSent && handleLinkSent();
        }
        setIsEsignModal(false), setMobileActive(false), setMailActive(false), setIsTimeUp(false);
      }}
    >
      {step === "1" && (
        <div>
          <div className="flex flex-col items-center my-8">
            <h1 className="font-semibold text-[20px]">Receive link on</h1>
            <div className="flex mt-10">
              <div className="w-64 h-auto p-5">
                <Button
                  onClickHandler={() => handleMobileNumber()}
                  isLoading={isDisabled.mobileLoader}
                  className={clsx(
                    "flex justify-between items-center rounded-lg p-5",
                    mobileActive ? "bg-primary-300 text-white" : "bg-primary-800"
                  )}
                >
                  <MobileIcon />
                  <h1 className="ml-3 text-[20px]">Mobile Number</h1>
                </Button>
              </div>
              <div className="w-64 h-auto p-5">
                <Button
                  isLoading={isDisabled.emailLoader}
                  onClickHandler={() => handleMail()}
                  className={clsx(
                    "flex justify-between items-center rounded-lg p-5",
                    mailActive ? "bg-primary-300 text-white" : "bg-primary-800"
                  )}
                >
                  <MailIcon />
                  <h1 className="text-[20px]">Mail</h1>
                </Button>
              </div>
            </div>
            {/* <div
              onClick={handleDoLaterA2Form}
              className="mt-10 flex flex-col items-center cursor-pointer"
            >
              <h1 className="text-primary font-semibold text-[20px]">Do it later</h1> */}
            <ErrorField errorMessage={error} />
            {/* </div> */}
          </div>
        </div>
      )}
      {step === "2" && (
        <div className="flex flex-col items-center py-10">
          <div className="w-2/5 mb-10">
            {mobileActive ? (
              <h1 className="text-center text-[15px] lg:text-[20px] text-primary font-semibold">
                A link has been sent to your registered mobile number. Please draw your signature
                and submit the same
              </h1>
            ) : (
              <h1 className="text-center text-[15px] lg:text-[20px] text-primary font-semibold">
                A link has been sent to your registered email Id. Please draw your signature and
                submit the same
              </h1>
            )}
          </div>
          <div className="mb-10">
            <h1 className="text-[15px] lg:text-[20px] font-semibold">
              Note- Please draw your signature as on your PAN card
            </h1>
          </div>
          <div className="mb-5">
            <h1 className="text-[15px] lg:text-[20px] font-semibold">Awaiting your signature.</h1>
          </div>
          <div className="flex space-x-2 animate-pulse mb-10">
            <div className="w-3 h-3 bg-gray-500 rounded-full"></div>
            <div className="w-3 h-3 bg-gray-500 rounded-full"></div>
            <div className="w-3 h-3 bg-gray-500 rounded-full"></div>
          </div>
          {clickedCount > 2 && !isTimeUp && (
            <div className="w-full text-center">
              <span className="font-semibold text-[12.2px] ">{formatTime(timeLeft)}</span>
            </div>
          )}
          <Button
            disabled={clickedCount > 2 && !isTimeUp}
            bgColor={clickedCount > 2 && !isTimeUp ? "bg-gray-600" : "bg-primary"}
            isLoading={mobileActive ? isDisabled?.mobileLoader : isDisabled?.emailLoader}
            onClickHandler={
              mobileActive ? () => handleMobileNumber("popup") : () => handleMail("popup")
            }
            className="border border-primary text-white font-semibold py-2 px-4 rounded-full text-[15px] lg:text-[20px]"
          >
            Resend link
          </Button>
        </div>
      )}

      {step === "3" && (
        <div className="flex flex-col items-center py-10">
          <div className="mb-7">
            <h1 className="text-[20px] lg:text-[25px] font-bold">Your form has been signed</h1>
          </div>
          <div className="mb-8">
            <h1 className="text-[15px] lg:text-[20px] font-semibold">Thanks for completion!</h1>
          </div>
          <div className="mb-5">
            <SuccessIcon />
          </div>
          <div className="mb-5 cursor-pointer">
            <h1
              onClick={(e) => handleA2Form && handleA2Form(e)}
              className="cursor-pointer text-[15px] lg:text-[20px] text-primary font-bold"
            >
              Download A2
            </h1>
          </div>
          <div>
            <h1
              onClick={() => {
                setIsEsignModal(false, setStep("1"));
              }}
              className="cursor-pointer text-[15px] lg:text-[20px] text-primary font-bold"
            >
              Go Back
            </h1>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default EsignHistoryModal;
